var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDescending = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.17853 13.3342L-2.61877e-05 14.5126L2.74427 17.2557C3.07005 17.5813 3.59801 17.5813 3.92283 17.2557L6.66675 14.5126L5.48819 13.3332L4.16678 14.655L4.16678 2.50005L2.49994 2.50005L2.49994 14.655L1.17853 13.3342Z",
  fill: "#313D48"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33301 4.16672H19.9999V5.83337H8.33301V4.16672Z",
  fill: "#313D48"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33301 7.5H17.4998V9.16665H8.33301V7.5Z",
  fill: "#313D48"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33301 10.8332H14.9998V12.5H8.33301V10.8332Z",
  fill: "#313D48"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33301 14.1668H12.4998V15.8332H8.33301V14.1668Z",
  fill: "#313D48"
})));
export default SvgDescending;